import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import * as dat from 'dat.gui'
import { DirectionalLight, PointLightHelper, Vector3 } from 'three'

    $(document).on('mousemove', function(e) {
      $('#circularcursor').css({
        left: e.pageX,
        top: e.pageY
      });
    })
  
// Debug
const gui = new dat.GUI()
gui.hide()
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */
//Textures Loader
let loadingDone = false
const loadingBar = document.querySelector('.loadingBar')

const loadingManager = new THREE.LoadingManager(
    () =>{
        document.querySelector('.overlay').classList.add('fade')
        document.querySelector('.loadingBarBG').classList.add('fade')
        loadingBar.classList.add('fade')
        loadingDone = true

    },
    (itemUrl, loaded, total)=>{
        const progressRatio = loaded/total
        loadingBar.style.transform = 'scaleX('+ progressRatio +')'
    }
)

const cubeTextureLoader = new THREE.CubeTextureLoader(loadingManager)
const envMap = cubeTextureLoader.load(
    ['environmentMaps/px.jpg',
     'environmentMaps/nx.jpg',
     'environmentMaps/py.jpg',
     'environmentMaps/ny.jpg',
     'environmentMaps/pz.jpg',
     'environmentMaps/nz.jpg'])
envMap.encoding= THREE.sRGBEncoding
scene.background = envMap
scene.environment = envMap

const texturesLoader = new THREE.TextureLoader(loadingManager)
const floorColor = texturesLoader.load('Textures/floor/color.jpg')
const floorNormal = texturesLoader.load('Textures/floor/normal.jpg')

const doorColor = texturesLoader.load('Textures/door/basecolor.jpg')
const doorNormal = texturesLoader.load('Textures/door/normal.jpg')
const doorHeight = texturesLoader.load('Textures/door/height.png')
const doorOpacity = texturesLoader.load('Textures/door/opacity.jpg')
const doorMetallic = texturesLoader.load('Textures/door/metallic.jpg')
const doorRoughness = texturesLoader.load('Textures/door/roughness.jpg')
const doorAO = texturesLoader.load('Textures/door/ambientOcclusion.jpg')


floorColor.repeat.set(4.5, 3.2)
floorColor.wrapS = THREE.MirroredRepeatWrapping
floorColor.wrapT = THREE.MirroredRepeatWrapping

floorNormal.repeat.set(4.5, 3.2)
floorNormal.wrapS = THREE.MirroredRepeatWrapping
floorNormal.wrapT = THREE.MirroredRepeatWrapping

floorNormal.wrapS = floorNormal.wrapT = THREE.RepeatWrapping;
floorColor.wrapS = floorColor.wrapT = THREE.RepeatWrapping;

//Models Loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Objects
 */

//room
let room = null

gltfLoader.load('models/room/myRoom.glb',
(gltf)=>{
    room = gltf.scene
    room.scale.set(15,15,15)
    room.children.forEach(element => {
        if (element.name == "bed1" || element.name =="bed2" || element.name =="tv_LCD") {
            element.children.forEach(elementy => {
                elementy.castShadow = true

            });
        }
        if (element.name == "Dessk" || element.name == "Ceiling" ||
            element.name == "Mouse") {
            element.castShadow = false
            element.receiveShadow = true
        }
        else if (element.name == "OfficeChair" || element.name == "ball" || element.name == "Mug") {
            element.castShadow = true
            element.receiveShadow = false
        }
        else if (element.name == "Tea")
        {
            element.castShadow = false
            element.receiveShadow = false
        }
        else {
            element.castShadow = true
            element.receiveShadow = true
        }



    });
    scene.add(room)
})
//floor

const floor = new THREE.Mesh(new THREE.PlaneBufferGeometry(4.5, 3.46),
    new THREE.MeshStandardMaterial({
        map: floorColor,
        normalMap: floorNormal,
        normalScale: new THREE.Vector2(1, 1)

    }))
floor.rotation.x = - Math.PI/2
floor.position.z= 1.8
floor.scale.set(15, 15, 15)
floor.receiveShadow = true
scene.add(floor)



//Door
const door = new THREE.Mesh(new THREE.PlaneBufferGeometry(1.88, 1.88, 100, 100),
new THREE.MeshStandardMaterial({
    map:doorColor,
    normalMap:doorNormal,
    aoMap: doorAO,
    aoMapIntensity: .5,
    displacementMap: doorHeight,
    displacementScale: .05,
    metalnessMap: doorMetallic,
    roughnessMap: doorRoughness,
    alphaMap: doorOpacity,
    transparent: true
}))
door.geometry.setAttribute('uv2', new THREE.BufferAttribute(door.geometry.attributes.uv.array,2))
door.rotation.y=- Math.PI/2
door.position.set(33.7, 12.8, -15.5)
door.scale.set(12,15,15)
scene.add(door)

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, .5)
scene.add(ambientLight)

const pointLight = new THREE.PointLight(0xffffff, 0.4)
pointLight.position.y = 33.8
pointLight.castShadow = true
pointLight.shadow.normalBias = .09
// pointLight.shadow.radius = 2
scene.add(pointLight)
gui.add(pointLight.position , 'x', -10 , 40 ,.001)
gui.add(pointLight.position , 'y', -10 , 35 ,.001)
gui.add(pointLight.position , 'z', -20 , 10 ,.001)
gui.add(pointLight , 'intensity', 0 , 10 ,.001)

/**
 * Sizes
 */

//CameraBounderies
var box = new THREE.Box3();
const boxBounderies = new THREE.Mesh( new THREE.BoxBufferGeometry(3.9, 2 ,3.0), new THREE.MeshBasicMaterial({
    transparent: true, opacity: 0
}))
boxBounderies.position.set(0, 17.7, 0)
boxBounderies.scale.set(15,15,15)
scene.add(boxBounderies)
box.setFromObject(boxBounderies);

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(65, sizes.width / sizes.height, 0.1, 1000)
camera.position.x = 2
camera.position.y = 15
camera.position.z = -10
// camera.position.x = 2
// camera.position.y = 15
// camera.position.z = -10
camera.lookAt(new Vector3(5,15,5))
scene.add(camera)


gui.add(camera.rotation , 'y', -10 , 35 ,.001)
gui.add(camera.rotation , 'z', -20 , 10 ,.001)
// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.toneMapping = THREE.LinearToneMapping
renderer.shadowMap.enabled = true
/**
 * Animate
 */

const clock = new THREE.Clock()

const tick = () =>
{

    const elapsedTime = clock.getElapsedTime()

    // Update objects

    if(camera.position.x > box.max.x){
        camera.position.x = box.max.x;
    }

    if(camera.position.x < box.min.x){
        camera.position.x = box.min.x;
    }

    if(camera.position.y > box.max.y){
        camera.position.y = box.max.y;
    }

    if(camera.position.y < box.min.y){
        camera.position.y = box.min.y;
    }

    if(camera.position.z > box.max.z){
        camera.position.z = box.max.z;
    }

    if(camera.position.z < box.min.z){
        camera.position.z = box.min.z;
    }

    //Loading Screen
    controls.update()
    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()